import { createContext, useRef } from 'react';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { RelatedDataStore } from './related-data-store';

export const RelatedDataStoreContext = createContext<RelatedDataStore | undefined>(undefined);

interface RelatedDataStoreProviderProps {
    eventId?: number;
}

export const RelatedDataStoreProvider: React.FC<RelatedDataStoreProviderProps> = ({
    eventId,
    children,
}) => {
    const storeRef = useRef<RelatedDataStore>();
    const { enhancedRelatedData } = useEnabledFeatures();

    if (storeRef.current === undefined) {
        storeRef.current = new RelatedDataStore(enhancedRelatedData, eventId);
    }

    return (
        <RelatedDataStoreContext.Provider value={storeRef.current}>
            {children}
        </RelatedDataStoreContext.Provider>
    );
};
